import { useTranslation } from 'react-i18next';
import Spinner from '@/components/@IntranetLibrary/Spinner';
import EmptyState from './EmptyState';
import ResultList from './ResultList';
import { EmptyMessage, LoadingMessage, ResultListBox } from './styles';
import type { RelatedApprovalItem } from './types';

type ResultLayerProps = {
  isOpen: boolean;
  items: RelatedApprovalItem[];
  isLoading?: boolean;
  hasError?: boolean;
  /** keyword 길이가 검색 최소치 미만 — 안내 문구 표시 */
  belowMinLength?: boolean;
  onSelect: (item: RelatedApprovalItem) => void;
  onOpenInNewWindow: (docId: string) => void;
  onItemKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
};

// 검색 결과 dropdown 레이어 — 결과/로딩/에러/빈 상태 모두 동일한 박스(보더 + 그림자) 안에 렌더.
const ResultLayer = ({
  isOpen,
  items,
  isLoading,
  hasError,
  belowMinLength,
  onSelect,
  onOpenInNewWindow,
  onItemKeyDown,
}: ResultLayerProps) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  if (belowMinLength) {
    return (
      <ResultListBox>
        <EmptyMessage>{t('2글자 이상 입력해 주세요.')}</EmptyMessage>
      </ResultListBox>
    );
  }

  if (isLoading) {
    return (
      <ResultListBox>
        <LoadingMessage>
          <Spinner theme="black" size="16px" />
        </LoadingMessage>
      </ResultListBox>
    );
  }

  if (hasError) {
    return (
      <ResultListBox>
        <EmptyMessage>
          {t(
            '데이터를 불러오는 중 오류가 생겼어요. IT Service로 접수해 주세요.',
          )}
        </EmptyMessage>
      </ResultListBox>
    );
  }

  return (
    <ResultListBox>
      {items.length === 0 ? (
        <EmptyState />
      ) : (
        <ResultList
          items={items}
          onSelect={onSelect}
          onOpenInNewWindow={onOpenInNewWindow}
          onItemKeyDown={onItemKeyDown}
        />
      )}
    </ResultListBox>
  );
};

export default ResultLayer;
